<template>
    <painel titulo="Elaborar Edital" icone="pi pi-angle-double-right" :mostrarRefresh="false">
        <div class="col-12">
            <div class="formgrid grid p-fluid">
                <label class="field col-12 md:col-12 required">Anexos</label>
                <div class="flex field col-12">
                    <FileUpload
                        ref="fileUpload"
                        :multiple="true"
                        :customUpload="true"
                        @uploader="arquivoSelecionado"
                        mode="basic"
                        chooseLabel="Anexar"
                        :auto="true"
                        :disabled="isDisabled"
                    />
                </div>
            </div>
            <div class="mt-2" v-for="(anexo, index) in anexos" :key="index">
                <strong>{{ anexo.name }}</strong>
                <i class="pi pi-trash p-error icon-button ml-2" style="font-size: 1.2rem" @click="limparArquivo(index)"></i>
            </div>
            <div class="formgrid grid p-fluid mt-4">
                <label class="field col-12 md:col-12">Observação</label>

                <div class="field col-6">
                    <Textarea type="text" v-model="observacao" maxlength="1000" :disabled="isDisabled" />
                </div>
            </div>
            <!-- Botão Finalizar Edital -->
            <Button label="Salvar" @click="confirmarAcao()" icon="pi pi-check-circle" class="p-button-primary" :disabled="isDisabled || anexos.length === 0" />
            <DropdownEtapas
                :etapasSolicitacaoDto="solicitacao.etapasSolicitacaoDto"
                :solicitacao="solicitacao"
                :isDisabled="isDisabled"
                :observacao="observacao"
                :anexos="anexos"
            />
            <AccordionEtapas :etapas="etapasFiltradas" />
        </div>
    </painel>
</template>

<script>
import service from './service';
import DropdownEtapas from '../DropdownEtapas.vue';
import { etapasSolicitacaoEnum } from '../../enum/etapasSolicitacaoEnum';
import AccordionEtapas from '../TabelaObservacaoEtapa.vue';

export default {
    data() {
        return {
            anexos: [],
            observacao: '',
            etapasFiltradas: [],
            etapasEnum: etapasSolicitacaoEnum,
        };
    },
    props: {
        isDisabled: {
            type: Boolean,
            default: false,
        },
        solicitacao: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        DropdownEtapas,
        AccordionEtapas,
    },
    emits: ['atualizarSolicitacao'],
    methods: {
        filtrarEtapasPorEnum(etapas, enumValor) {
            return etapas.filter((etapa) => etapa.etapa === enumValor);
        },
        pegarUltimaEtapa() {
            return this.solicitacao.etapasSolicitacaoDto
                .filter((e) => e.etapa == this.etapasEnum.ELABORAR_EDITAL)
                .sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))[0];
        },
        arquivoSelecionado(event) {
            for (let file of event.files) {
                this.anexos.push(file);
            }

            this.$refs.fileUpload.clear();
        },
        limparArquivo(index) {
            this.anexos.splice(index, 1);
        },

        ElaborarEditalLicitacao() {
            if (this.isDisabled) return;
            this.$store.dispatch('addRequest');
            service.ElaborarEditalLicitacao(this.$route.params.id, this.anexos, this.observacao).then((response) => {
                if (response && response.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Enviado para validar',
                        detail: 'Edital enviado para validar com sucesso',
                        life: 3000,
                    });
                    this.$store.dispatch('setAtualizar', true);
                    this.$emit('atualizarSolicitacao');
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro ao enviar para validação',
                        detail: 'Erro ao enviar para validação',
                        life: 3000,
                    });
                }
                this.$store.dispatch('removeRequest');
            });
        },
        confirmarAcao() {
            this.$confirm.require({
                message: `Deseja confimar a Elaboração de edital?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.ElaborarEditalLicitacao();
                },
            });
        },
    },
    watch: {
        solicitacao(newSolicitacao) {
            if (newSolicitacao && newSolicitacao.etapasSolicitacaoDto) {
                this.etapasFiltradas = this.filtrarEtapasPorEnum(newSolicitacao.etapasSolicitacaoDto, etapasSolicitacaoEnum.ELABORAR_EDITAL);
                const etapa = newSolicitacao.etapasSolicitacaoDto.find((e) => e.etapa === etapasSolicitacaoEnum.ELABORAR_EDITAL);
                if (etapa) {
                    this.observacao = etapa.observacao;
                }
            }
        },
    },
};
</script>
